
import React, { useState, useEffect } from 'react';
import { StarIcon } from './icons';

interface StarRatingProps {
  onRating: (rating: number) => void;
  initialRating?: number;
  size?: number; // Added size prop
  activeColor?: string;
  inactiveColor?: string;
}

const StarRating: React.FC<StarRatingProps> = ({ 
  onRating, 
  initialRating = 0, 
  size = 8, 
  activeColor = 'text-yellow-400', 
  inactiveColor = 'text-gray-300' 
}) => {
  const [rating, setRating] = useState(initialRating);
  const [hover, setHover] = useState(0);

  useEffect(() => {
    setRating(initialRating);
  }, [initialRating]);

  return (
    <div className="flex items-center gap-1">
      {[...Array(5)].map((_, index) => {
        const ratingValue = index + 1;
        const isFilled = ratingValue <= (hover || rating);
        
        return (
          <label
            key={index}
            onMouseEnter={() => setHover(ratingValue)}
            onMouseLeave={() => setHover(0)}
            onClick={() => {
                setRating(ratingValue);
                onRating(ratingValue);
            }}
            className="transition-transform active:scale-95 cursor-pointer"
          >
            <input
              type="radio"
              name="rating"
              value={ratingValue}
              className="hidden"
            />
            <StarIcon
              className={`transition-all duration-200 fill-current
                ${isFilled ? activeColor : inactiveColor} 
                ${isFilled ? 'drop-shadow-[0_0_8px_rgba(250,204,21,0.4)]' : ''}`}
              style={{ width: `${size * 4}px`, height: `${size * 4}px` }} // Tailwind classes are w-8 = 32px, so size*4
            />
          </label>
        );
      })}
    </div>
  );
};

export default StarRating;
